<template>
  <div class="h-full">
    <div
      class="flex flex-wrap sm:flex-nowrap items-center justify-between my-4 lg:my-8"
    >
      <!-- title -->
      <div class="order-1 flex-grow flex items-center">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 40 40"
          class="block w-8 h-8 stroke-current text-navy"
        >
          <g transform="matrix(1.6666666666666667,0,0,1.6666666666666667,0,0)">
            <path
              d="M12.75 15.75h3v4.5l4.5-4.5h1.494a1.506 1.506 0 0 0 1.506-1.506V2.25a1.5 1.5 0 0 0-1.5-1.5h-12a1.5 1.5 0 0 0-1.5 1.5v4.5m11.625 1.125h0"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
            <path
              d="M19.875 7.875a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m-7.5 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m3.75 0h0m0 0a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
            <circle
              cx="6.75"
              cy="13.125"
              r="3.375"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></circle>
            <path
              d="M12.75 23.25a6.054 6.054 0 0 0-12 0"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
            ></path>
          </g>
        </svg>

        <span class="ml-2 text-navy font-bold leading-7 text-2xl">
          Organisations
        </span>
      </div>

      <!-- Back to Organisation List -->
      <div class="order-2 sm:order-3 sm:mr-3">
        <inertia-link
          class="flex items-center justify-center w-7 h-7 rounded-full bg-navy hover:bg-navy-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-navy-light"
          :href="route('app.organisation.index')"
        >
          <svg-icon
            type="mdi"
            size="20"
            :path="icons.back"
            class="text-white"
          />
          <span class="sr-only"> Organisations List </span>
        </inertia-link>
      </div>
    </div>

    <flash-message></flash-message>

    <div class="border-b border-navy-light">
      <nav class="-mb-px flex space-x-8 w-full overflow-auto" aria-label="Tabs">
        <!-- Information -->
        <a
          v-on:click.stop="tab = 'info'"
          :class="{
            'text-navy-dark': tab == 'info',
            'border-navy-dark': tab == 'info',
            'font-bold': tab == 'info',
          }"
          class="border-transparent text-navy hover:text-navy-dark hover:border-navy-dark group flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
        >
          <svg-icon type="mdi" size="20" :path="icons.info" class="mr-1" />
          <span>Information</span>
        </a>

        <!-- Labs -->
        <a
          v-on:click.stop="tab = 'labs'"
          :class="{
            'text-navy-dark': tab == 'labs',
            'border-navy-dark': tab == 'labs',
            'font-bold': tab == 'labs',
          }"
          class="border-transparent text-navy hover:text-navy-dark hover:border-navy-dark group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
        >
          <svg-icon
            type="mdi"
            size="20"
            :path="icons.soilAnalysis"
            class="mr-1"
          />
          <span>Labs</span>
        </a>

        <!-- Farmers -->
        <a
          v-on:click.stop="tab = 'farmers'"
          :class="{
            'text-navy-dark': tab == 'farmers',
            'border-navy-dark': tab == 'farmers',
            'font-bold': tab == 'farmers',
          }"
          class="border-transparent text-navy hover:text-navy-dark hover:border-navy-dark group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
        >
          <svg-icon type="mdi" size="20" :path="icons.farms" class="mr-1" />
          <span>Farmers</span>
        </a>

        <!-- Tasks -->
        <a
          v-on:click.stop="tab = 'tasks'"
          :class="{
            'text-navy-dark': tab == 'tasks',
            'border-navy-dark': tab == 'tasks',
            'font-bold': tab == 'tasks',
          }"
          class="border-transparent text-navy hover:text-navy-dark hover:border-navy-dark group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
        >
          <svg-icon type="mdi" size="20" :path="icons.tasks" class="mr-1" />
          <span>Tasks</span>
        </a>

        <!-- Reports -->
        <a
          v-on:click.stop="tab = 'reports'"
          :class="{
            'text-navy-dark': tab == 'reports',
            'border-navy-dark': tab == 'reports',
            'font-bold': tab == 'reports',
          }"
          class="border-transparent text-navy hover:text-navy-dark hover:border-navy-dark group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
        >
          <svg-icon type="mdi" size="20" :path="icons.reports" class="mr-1" />
          <span>Reports</span>
        </a>

        <!-- Users -->
        <a
          v-on:click.stop="tab = 'users'"
          :class="{
            'text-navy-dark': tab == 'users',
            'border-navy-dark': tab == 'users',
            'font-bold': tab == 'users',
          }"
          class="border-transparent text-navy hover:text-navy-dark hover:border-navy-dark group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
        >
          <svg-icon type="mdi" size="20" :path="icons.users" class="mr-1" />
          <span>Users</span>
        </a>

        <!-- Soil Samplers -->
        <a
          v-on:click.stop="tab = 'soilsamplers'"
          :class="{
            'text-navy-dark': tab == 'soilsamplers',
            'border-navy-dark': tab == 'soilsamplers',
            'font-bold': tab == 'soilsamplers',
          }"
          class="border-transparent text-navy hover:text-navy-dark hover:border-navy-dark group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm cursor-pointer"
        >
          <svg-icon
            type="mdi"
            size="20"
            :path="icons.soilsamplers"
            class="mr-1"
          />
          <span>Soil Samplers</span>
        </a>
      </nav>
    </div>

    <div v-show="tab == 'info'">
      <organisation-information :organisation="organisation" />
    </div>

    <div v-show="tab == 'labs'">
      <organisation-labs
        :organisation="organisation"
        :labs="labs"
        :tests="tests"
      />
    </div>

    <div v-show="tab == 'farmers'">
      <organisation-farmers :farmers="farmers" />
    </div>

    <div v-show="tab == 'tasks'">
      <organisation-tasks :tasks="tasks" />
    </div>

    <div v-show="tab == 'reports'">
      <organisation-reports
        :organisation="organisation"
        :report_setting="report_setting"
      />
    </div>

    <div v-show="tab == 'users'">
      <organisation-users :users="users" />
    </div>

    <div v-show="tab == 'soilsamplers'">
      <organisation-soil-samplers :soilsamplers="soilsamplers" />
    </div>
  </div>
</template>

<script>
import AppLayout from "@/Layouts/App";
import OrganisationInformation from "@/Pages/Organisation/Partials/Information";
import OrganisationLabs from "@/Pages/Organisation/Partials/Labs";
import OrganisationFarmers from "@/Pages/Organisation/Partials/Farmers";
import OrganisationTasks from "@/Pages/Organisation/Partials/Tasks";
import OrganisationReports from "@/Pages/Organisation/Partials/Reports";
import OrganisationUsers from "@/Pages/Organisation/Partials/Users";
import OrganisationSoilSamplers from "@/Pages/Organisation/Partials/SoilSamplers";
import _ from "lodash";
import * as Icons from "@/Partials/icons";
export default {
  layout: [AppLayout],
  components: {
    OrganisationInformation,
    OrganisationLabs,
    OrganisationFarmers,
    OrganisationTasks,
    OrganisationReports,
    OrganisationUsers,
    OrganisationSoilSamplers,
  },

  props: {
    organisation: Object,
    users: Array,
    farmers: Array,
    tasks: Array,
    soilsamplers: Object,
    labs: Object,
    tests: Object,
    report_setting: Object,
  },

  data() {
    return {
      tab: "info",
      icons: {
        ...Icons,
      },
    };
  },

  methods: {},

  created() {},
};
</script>
